import { Badge, Button, Tabs, message } from 'antd'
import { SBack, SMessage, SSteps } from 'shj-components'
import { Children, useEffect, useRef, useState } from 'react'
import ChooseConstruction from './construction'
import ChooseMaterail from './material'
import styles from './index.module.less'
import HistoryModal from './historyModal'
import { findResponseListByPage } from '@/services/product'
import dayjs from 'dayjs'

export default function ChooseCategory() {
  const [tabsChoose, setTabsChoose] = useState('1')
  const [historyOpen, setHistoryOpen] = useState(false)
  const [count, setCount] = useState(0)

  const handleTabs = () => {
    const basicTabs = [
      {
        label: '从物料库选品',
        key: '1',
        children: <ChooseMaterail />,
      },
      {
        label: '从施工库选品',
        key: '2',
        children: <ChooseConstruction />,
      },
    ]
    return basicTabs
  }

  const onTabsChange = async (key: string) => {
    setTabsChoose(key)
  }

  const clickToHistory = () => {
    setHistoryOpen(true)
  }
  useEffect(() => {
    // 立即执行一次
    fetchData()
    // 每60秒轮询一次
    const timer = setInterval(fetchData, 60000)
    // 组件卸载时清除定时器
    return () => clearInterval(timer)
  }, [])
  const fetchData = () => {
    return new Promise((resolve, reject) => {
      const currentTime = dayjs().format('YYYY-MM-DD')
      console.log(currentTime)

      findResponseListByPage({
        current: 1,
        pageSize: 10,
        resultStatus: 'productSyncLogProcessing',
        createdTimeBegin: currentTime + ' 00:00:00',
        createdTimeEnd: currentTime + ' 23:59:59',
        countFlag: true,
      })
        .then(res => {
          setCount(res?.count || 0)
        })
        .catch(reject)
    })
  }
  return (
    <div className={styles.baseBox}>
      <Tabs
        style={{ backgroundColor: 'white', width: '100%' }}
        defaultActiveKey="1"
        onChange={onTabsChange}
        items={handleTabs()}
        tabBarExtraContent={
          <Badge count={count}>
            <Button style={{marginRight: '15px'}} onClick={clickToHistory}>
              提交记录
            </Button>
          </Badge>
        }
      />
      {historyOpen && (
        <HistoryModal open={historyOpen} onCancel={setHistoryOpen} title="提交记录"></HistoryModal>
      )}
    </div>
  )
}
